import { mutatorAction } from 'satcheljs';
import { type MailboxInfo } from 'owa-client-types';
import { getAsyncItemRegistry } from '../selectors/getAsyncItemRegistry';
import { type SeedStatus, type AsyncChatProviderId } from 'owa-copilot-async-chat-types';

export const setSeedStatusMutator: (
    mailboxInfo: MailboxInfo,
    providerId: AsyncChatProviderId,
    seedStatus: SeedStatus
) => void = mutatorAction('setSeedStatusMutator', (mailboxInfo, providerId, seedStatus) => {
    const registry = getAsyncItemRegistry(mailboxInfo);
    if (registry) {
        registry.seedStatusByProvider.set(providerId, seedStatus);
    }
});
